



import Vue, { PropType } from "vue";
import VueApexCharts from "vue-apexcharts";
import { CPMTransition } from "@/features/home/types";
import { getCurrencySign } from "@/commons/utils/currencySign";

type Series = { name: string; data: number[] };

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    series: [] as Series[],
    options: {},
  }),
  created() {
    this.updateData();
  },
  props: {
    chartData: { type: Object as PropType<CPMTransition> },
    height: { type: Number, default: 250 },
  },
  methods: {
    updateData() {
      this.series = [
        {
          name: "CPM",
          data: this.chartData.cpm,
        },
        {
          name: "CPM（推定市場平均）",
          data: this.chartData.avg,
        },
      ];
      this.options = {
        chart: {
          type: "area",
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
        },
        fill: {
          opacity: 0.1,
          type: "solid",
        },
        legend: {
          position: "top",
          fontSize: "10px",
          markers: {
            width: 10,
            height: 10,
          },
        },
        markers: {
          size: 2,
          strokeWidth: 0,
          hover: {
            sizeOffset: 2,
          },
        },
        colors: ["#289CF1", "#EC407A"],
        labels: this.chartData.date,
        xaxis: {
          labels: {
            style: { fontSize: "10px" },
          },
          tickAmount:
            this.chartData.date.length > 31
              ? this.chartData.date.length / 2
              : this.chartData.date.length,
        },
        yaxis: {
          tickAmount: 7,
          forceNiceScale: true,
          labels: {
            formatter: (value: any) => {
              if (value !== null) {
                return getCurrencySign() + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "--";
              }
            },
            gridLines: { display: false },
          },
        },
      };
    },
  },
});
